<template>
  <v-hover>
    <v-edit-dialog
      slot-scope="{ hover }"
      lazy
      large
      cancel-text="Отмена"
      save-text="Ок"
      hide-details
      @cancel="closeDialog"
      @open="openDialog"
      @save="save"
    >
      <div sclass="link">
        {{ editableValue }}
      </div>
      <div
        v-if="hover"
        class="icon-reveal"
      >
        <v-icon
          class="pb-3 pl-2"
          color="blue darken-2"
          size="13px"
        >
          edit
        </v-icon>
      </div>
      <v-text-field
        slot="input"
        v-model="editableValue"
        single-line
        autofocus
        outline
        hide-details
        class="my-2"
        :disabled="disabled"
      />
    </v-edit-dialog>
  </v-hover>
</template>
<script>
export default {
  props: ["value", "item", "index", "column", "disabled"],
  data() {
    return {
      editableValue: 0,
    };
  },
  computed: {
    selectedValue() {
      return this.$store.getters["oldVersionWarehouseDetails/selectedValue"];
    },
  },
  watch: {
    value: {
      handler(value) {
        if (value) {
          this.editableValue = value;
        }
      },
      immediate: true,
    },
  },
  methods: {
    openDialog() {
      this.$store.dispatch("oldVersionWarehouseDetails/openDialog", {
        value: this.editableValue,
        rowIndex: this.index,
      });
    },
    closeDialog() {
      this.editableValue = this.selectedValue;
      this.$store.dispatch("oldVersionWarehouseDetails/closeDialog");
    },
    async save() {
      if (Object.prototype.hasOwnProperty.call(this.item, this.column.name)) {
        this.item[this.column.name] = this.editableValue;
      }
      await this.$store.dispatch("oldVersionWarehouseDetails/save", this.item);
    },
  },
};
</script>
